<template>
  <div class="container box-card">
    <el-page-header @back="onReturn" title="返回" content="报名情况">
    </el-page-header>
    <enrolment
      :data="student"
      v-if="student.FormType == '新生报名'"
    ></enrolment>
    <parenting-class
      :data="student"
      v-if="student.FormType == '亲子班报名'"
    ></parenting-class>
  </div>
</template>

<script>
import Enrolment from "@/views/enrolment/view.vue";
import ParentingClass from "@/views/parentingclass/view.vue";
import { getStudent } from "@/utils/students";

export default {
  components: { Enrolment, ParentingClass },
  data() {
    return {
      active: "records",
      student: {},
    };
  },
  created: function () {
    this.student = getStudent(this.$route.query.id);
  },
  methods: {
    getId: function () {
      this.student = getStudent(this.$route.query.id);
    },
    onReturn: function() {
      this.$router.push("/controlcenter");
    },
  },
  watch: {
    $route: "getId",
  },
};
</script>
